const state = {
  isBoardReady: false, // 白板是否已经Ready
  currentFileInfo: {}, // 当前文件信息
  showMobilToolBar: true,
  eleToolbarUserInfo: {
    // UserRole: 1,
    // nick: "老师",
    // userID: "404347475656718",
  }, // 元素工具栏用户信息
  role: 3,
  isPc: true,
};
const mutations = {
  setRole(state, data) {
    state.role = data;
  },
  setEleToolbarUserInfo(state, data) {
    state.eleToolbarUserInfo = data;
  },
  setShowMobilToolBar(state, data) {
    state.showMobilToolBar = data;
  },
  setBoardReady(state, data) {
    state.isBoardReady = data;
  },
  setCurrentFileInfo(state, data) {
    state.currentFileInfo = data;
  },
  setIsPc(state, data) {
    state.isPc = data;
  },
};

const actions = {};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
